<template>
  <div class="flex flex-wrap gap-2">
    <a
      v-for="chip in chips"
      :key="chip.href"
      :href="chip.href"
      class="rounded-full bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-200 px-3 py-1 text-xs sm:text-sm"
    >
      {{ chip.label }}
    </a>
  </div>
</template>

<script setup lang="ts">
const chips = [
  { href: "#dates", label: "Tareekhen" },
  { href: "#conditions", label: "Shartain" },
  { href: "#niyat", label: "Niyat" },
  { href: "#women", label: "Aurton" },
  { href: "#registration", label: "Registration" },
  { href: "#essentials", label: "Essentials" },
  { href: "#schedule", label: "Schedule" },
];
</script>
